import { render, staticRenderFns } from "./currencyExplanation.vue?vue&type=template&id=93b18ae8"
import script from "./currencyExplanation.vue?vue&type=script&lang=js"
export * from "./currencyExplanation.vue?vue&type=script&lang=js"
import style0 from "./currencyExplanation.vue?vue&type=style&index=0&id=93b18ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports